import api from '@utils/api'
import { formatJsonId } from '@utils/general'

import { SET_CATALOG } from '@constants/actionType'
import {
  StatusVisible,
} from '@constants/general'

export const getProfilesCatalog = (querys) => async (dispatch, _getState) => {
  const response = await api.getProfiles(querys)
  if (querys.type === 'visible') {
    if (!response?.status) {
      dispatch({
        type: SET_CATALOG,
        payload: {nameCatalog: 'profileCatalog', data: response?.data || []}
      })
    }
  }
  return response
}

export const updateStatusProfile = ({ id, justification, estatus }) => async (_dispatch, _getState) => {
  let validateStatus = null
  if (estatus === StatusVisible.IS_VISIBLE) validateStatus = 'suspend'
  if (estatus === StatusVisible.IS_HIDDEN) validateStatus = 'activate'
  const data = {
    status: validateStatus,
    reason: justification
  }
  const response = await api.updateVisibilityProfile(id, data)
  return response;
};

export const deleteProfile  = ({id, justification}) => async (_dispatch, _getState) => {
  const data = {
    reason: justification
  }
  const response = await api.deleteProfle(id, data)
  return response
};

export const getPermissionCatalog = () => async (dispatch, _getState) => {
  const response = await api.getPermissionsCatalog()
  return response
}

export const createProfile = () => async (_dispatch, getState) => {
  const { general, permissionSelect, accessibility } = getState().profile
  const { keysLanguageCatalog } = getState().catalogs

  const data = {
    nombre: {},
    permisos: formatJsonId(permissionSelect),
    secciones: {
      navega: accessibility?.navega,
      lista: accessibility?.navega === "ALL" 
        ? []
        : accessibility?.sectionsSelected.length 
          ? formatJsonId(accessibility.sectionsSelected)
          : [],
    }
  }

  if (!accessibility?.hasPermissionSecOrDoc) {
    data.secciones.navega = "SOME"
    data.secciones.lista = []
  }

  keysLanguageCatalog.map(key => {
    data.nombre[key] = general[key].name
  })

  const response = await api.newProfile(data);
  return response;
};

export const editProfile = (justification) => async (_dispatch, getState) => {
  const { general, permissionSelect, accessibility, id } = getState().profile
  const { keysLanguageCatalog } = getState().catalogs

  const data = {
    id,
    nombre: {},
    permisos: formatJsonId(permissionSelect),
    secciones: {
      navega: accessibility?.navega,
      lista: accessibility?.navega === "ALL" 
        ? []
        : accessibility?.sectionsSelected.length 
          ? formatJsonId(accessibility.sectionsSelected)
          : [],
    },
    reason: justification
  }

  if (!accessibility?.hasPermissionSecOrDoc) {
    data.secciones.navega = "SOME"
    data.secciones.lista = []
  }

  keysLanguageCatalog.map(key => {
    data.nombre[key] = general[key].name
  })

  const response = await api.editProfile(data);
  return response;
};